<script setup lang="ts">
import {useModyApi} from "~/middelware/ModyApi";
import type {MenuItem} from "primevue/menuitem";
import {useRouter} from "vue-router";
import {onMounted} from "@vue/runtime-core";
import type {BlogCategory} from "~/utils/BlogCategory";

const api = useModyApi();
const menuItems = ref<MenuItem[]|undefined>([])
const router = useRouter();
const activeKey = ref<string|null>(null)

function convertCategoriesToMenuItems(categories:BlogCategory[]):MenuItem[]|undefined{
  let nodes:MenuItem[] = []
  nodes.push({
    key: "__all",
    label:"Letzte Beiträge",
    command() {
      router.push("/blog/")
    },
  })
  categories.forEach((category:BlogCategory)=>{
    const newNode:MenuItem = {
      key: String(category.id),
      label:category.name,
      command: ()=>{router.push("/blog/category/"+category.id)}
    }
    if(newNode.items) newNode.command = undefined
    nodes.push(newNode)
  })
  if(nodes.length == 0) return undefined
  return nodes
}

onMounted(async ()=>{
  const categories = await api.getBlogCategories();
  menuItems.value = convertCategoriesToMenuItems(categories)
  const route = useRoute()
  const catId = route.params.id
  activeKey.value = catId ? String(catId) : "__all"
})
</script>

<template>
  <div class="flex flex-wrap gap-2 px-4 py-5 justify-center max-w-5xl mx-auto">

    <!-- Skeleton -->
    <template v-if="menuItems?.length === 0">
      <Skeleton v-for="i in 5" :key="i" height="34px" width="120px" border-radius="999px" />
    </template>

    <!-- Kategorie-Pills -->
    <template v-else>
      <button
        v-for="item in menuItems"
        :key="item.key"
        class="px-4 py-[7px] rounded-full text-sm font-medium cursor-pointer border transition-all whitespace-nowrap"
        :class="item.key === activeKey
          ? 'bg-[#E39737] text-zinc-900 border-[#E39737]'
          : 'bg-transparent text-stone-400 border-zinc-600 hover:bg-zinc-700 hover:text-stone-200 hover:border-zinc-500'"
        @click="item.command?.(); activeKey = item.key ?? null"
      >
        {{ item.label }}
      </button>
    </template>

  </div>
</template>
